export default {
  products_format(products) {
    let output = {};

    products.forEach((item) => {
      output[item.id] = item;
    });

    return output;
  },
};
